export default __webpack_public_path__ + "3c3fda7c08bcc9544c642fea1a8d870c.svg";